import React, { useState } from 'react'
import styles from './DealsCardAppearance.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormField from 'components/UI/AsideModal/Form/FormField'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import ToggleCheckbox from '../../../../../../UI/ToggleCheckbox/ToggleCheckbox'

const DealsCardAppearance = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore
  const [isRemember, setIsRemember] = useState(false)
  const [isRemember2, setIsRemember2] = useState(false)
  const [isRemember3, setIsRemember3] = useState(false)
  return (
    <div className={styles.groupForm}>
      <ToggleCheckbox
        checked={isRemember}
        label={'Apply to all funnels'}
        onChange={() => setIsRemember(!isRemember)}
      />
      <ToggleCheckbox
        checked={isRemember2}
        label={'Show contact avatar'}
        onChange={() => setIsRemember2(!isRemember2)}
      />
      <ToggleCheckbox
        checked={isRemember3}
        label={'Show last message from a contact'}
        onChange={() => setIsRemember3(!isRemember3)}
      />

      <div className={styles.fieldSet}>
        <FormField>
          <FormLabel isRequired>{'Contact:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Free training:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'No meaning:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('Name')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Responsible:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Date of creation:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
        <FormField>
          <FormLabel isRequired>{'Transaction budget:'}</FormLabel>
          <SelectCustom
            placeholder={'Name'}
            options={[]}
            sortKey='name'
            valueID={modalValue.company}
            onChange={(o) => changeValues(o.id, 'company')}
            error={check('company')}
          />
        </FormField>
      </div>
      <FormField>
        <FormLabel isRequired>{'Transaction budget:'}</FormLabel>
        <SelectCustom
          placeholder={'Name'}
          options={[]}
          sortKey='name'
          valueID={modalValue.company}
          onChange={(o) => changeValues(o.id, 'company')}
          error={check('company')}
        />
      </FormField>

      {isRemember3 && (
        <div className={styles.messageExample}>
          <img src='https://i.ibb.co/Dfqpttr/Avatar-w-photo.png' alt='avatar' />

          <div className={styles.messageExampleText}>
            <span className={styles.messageText}>
              The last message from the client will be shown here.
            </span>
            <span className={styles.messageDate}>Yesterday 19:42:15.711</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default DealsCardAppearance
